import React from 'react';
import { Grid2, Paper, Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import footer1 from '../assets/images/Footer-1.png';
import footer2 from '../assets/images/Footer-2.png';
import footer3 from '../assets/images/Footer-3.png';
import footer4 from '../assets/images/Footer-4.png';
import Snackbars from '../utils/Snackbars';

// Footer menu items array
const footerMenuItems = [
    { id: 1, image: footer1, label: 'Events', url: '/dashboard' },
    { id: 2, image: footer2, label: 'My Tickets', url: '/my-tickets' },
    { id: 3, image: footer3, label: 'Resell MKT', url: '/resell-market' },
    { id: 4, image: footer4, label: 'My Wallet', url: '/wallet-balance' },
];

// Define restricted routes for guests
const restrictedRoutes = ['/my-tickets', '/my-wallet', '/wallet-balance'];

// Minimal Item component
const Item = ({ children }) => (
    <Paper elevation={0} style={{ textAlign: 'center' }}>
        {children}
    </Paper>
);

const Footer = () => {
    const TokenDetails = JSON.parse(localStorage.getItem('userDetails'));
    const location = useLocation(); // Get the current path
    const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
    });
    const resetAlertData = () => {
        setTimeout(() => {
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
            }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
    };

    // Handle navigation restriction for guest users
    const handleRestrictedClick = (event, url) => {
        if (TokenDetails?.guestMode && restrictedRoutes.includes(url)) {
            event.preventDefault(); // Prevent navigation
            setAlertData({ variant: "error", message: "Please login to access this functionality." });
            resetAlertData(); // Call the reset function
        }
    };

    return (
        <Grid2 className="footer">
            <Box sx={{ flexGrow: 1 }}>
                {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
                <Grid2 container spacing={2}>
                    {footerMenuItems.map((menu) => (
                        <Grid2 size={3} key={menu.id} className={`footer-menu ${location.pathname === menu.url ? 'active' : ''}`}>
                            <Link 
                                to={menu.url} 
                                style={{ textDecoration: 'none', color: 'inherit' }} 
                                onClick={(event) => handleRestrictedClick(event, menu.url)}
                            >
                                <Item> <img src={menu.image} alt={menu.label} width={26} /> </Item>
                                <Item>{menu.label}</Item>
                            </Link>
                        </Grid2>
                    ))}
                </Grid2>
            </Box>
        </Grid2>
    );
};

export default Footer;
